import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Chip, Tooltip, alpha, useTheme } from "@mui/material";

import type { FC } from "react";

export const ANY_LINK_DYNAMIC_TOOLTIP =
  "This Communication contains links within dynamic content blocks, which may not have been received by everyone.";

export const SPECIFIC_LINK_DYNAMIC_TOOLTIP =
  "This link is within a dynamic content block, so may not have been received by everyone.";

export const SURVEY_DYNAMIC_TOOLTIP =
  "This survey is within a dynamic content block, so may not have been received by everyone. If you use this survey, even those who did not receive the survey will get a Follow-Up message.";

export const DynamicContentChip: FC<{ tooltipText: string }> = ({ tooltipText }) => {
  const theme = useTheme();
  const backgroundColor = alpha(theme.palette.warning.main, 0.12);
  const color = theme.palette.warning.dark;

  return (
    <Tooltip title={tooltipText}>
      <Chip
        size="small"
        icon={<WarningAmberIcon />}
        label="Dynamic Content"
        sx={{
          "&.MuiChip-root": { backgroundColor, color, width: "fit-content" },
          "& .MuiChip-icon": { color },
        }}
      />
    </Tooltip>
  );
};
